<template>
  <div class="c-modal c-modal--reward-order t-modal">



    <section class="c-modal__box c-modal--reward-order__box">


      <div class="c-modal--reward-order__box__content">

        <div class="c-modal--reward-order__points-cost">
          <h2 class="c-modal--reward-order__points-cost__title t-headline">{{ $t('web.catalog_order_modal.modal_title') }}</h2>
          <p class="c-modal--reward-order__points-cost__data">
            <i class="fa fa-star t-points-icon"></i>
            <vue-numeric
              v-show="!priceOutOfRange"
              separator=","
              :read-only="true"
              :value="totalPrice"
              class="c-modal--reward-order__points-cost__data__number">
            </vue-numeric>
            <span v-if="priceOutOfRange">{{ $t('web.catalog_order_modal.invalid_amount') }}</span>
          </p>
        </div>

        <h2 class="c-modal--reward-order__shipping-info__h2 reward_name" v-if="hasRange">{{ rewardDetails.name }}</h2>

        <div class="c-modal--reward-order__points-cost quantity_container">
          <div v-if="hasRange">
            <h3 class="c-modal--reward-order__shipping-info__h2 quantity_label"><i class="fa fa-star t-points-icon"></i>{{rewardDetails['supplier_items'][0]['currency']}} {{ $t('web.catalog_order_modal.amount') }}</h3>
            <vue-numeric
              separator=","
              :currency="rewardDetails['supplier_items'][0]['currency']"
              v-model="dollarPriceInserted"
              class="c-modal--reward-order__points-cost__data__number">
            </vue-numeric>
            <span :class="{'c-validation t-alert-danger': priceOutOfRange}">
              {{ $t('web.catalog_order_modal.default_dollar_amount_message', { min_price: minDefDollarPrice, max_price: maxDefDollarPrice }) }}
            </span>
          </div>

          <h2 class="c-modal--reward-order__shipping-info__h2 reward_name" v-if="!hasRange">{{ rewardDetails.name }}</h2>

          <div class="quantity_select_container">
            <h3 class="c-modal--reward-order__shipping-info__h2 quantity_label">{{ $t('web.catalog_order_modal.quantity') }}</h3>
            <select class="c-modal--reward-order__points-cost__data quantity_select" name="quantity" v-model="quantity" tabindex="5">
              <option v-for="n in 25" :key="n" :value="n" >{{ n }}</option>
            </select>
          </div>
        </div>

        <div class="c-modal--reward-order__math">
          <dl class="c-modal--reward-order__math__dl">
            <dd class="c-modal--reward-order__math__dl__number">
              <vue-numeric
                separator=","
                :read-only="true"
                v-model="participant.points_balance">
              </vue-numeric>
            </dd>
            <dt class="c-modal--reward-order__math__dl__description">
              {{ $t('web.catalog_order_modal.current_points') }}
            </dt>
          </dl>
          <dl class="c-modal--reward-order__math__dl">
            <dd class="c-modal--reward-order__math__dl__number">
              <strong>
                &ndash;
                <vue-numeric
                  separator=","
                  :read-only="true"
                  :value="totalPrice">
                </vue-numeric>
              </strong>
            </dd>
            <dt class="c-modal--reward-order__math__dl__description t-headline">
              {{ $t('web.catalog_order_modal.reward_cost') }}
            </dt>
          </dl>
          <dl class="c-modal--reward-order__math__dl">
            <dd class="c-modal--reward-order__math__dl__number">
              <i class="fa fa-star t-points-icon"></i>
              <vue-numeric
                separator=","
                :read-only="true"
                v-model="this.pointsBalance">
              </vue-numeric>
            </dd>
            <dt class="c-modal--reward-order__math__dl__description">
              {{ $t('web.catalog_order_modal.points_left') }}
            </dt>
          </dl>
        </div>

        <div class="c-modal--reward-order__note">
          <i18n path="web.catalog_order_modal.address_confirmation" tag="p" class="u-small-paragraph u-center-text u-no-margins">
            <template v-slot:profile_link>
                <router-link class="t-link" :to="{name: 'Settings'}">{{ $t('web.catalog_order_modal.address_confirmation_link') }}</router-link>
            </template>
          </i18n>
          <p v-if="showGiftCardMessage" class="u-small-paragraph u-center-text u-no-margins">
            <strong>
              <span style="text-transform:uppercase">**<u>{{ $t('web.catalog_order_modal.important') }}</u></span>: 
              {{ $t('web.catalog_order_modal.gift_card_cancellation_message') }}
            </strong>
          </p>
        </div>

        <div v-if="!editingAddress" class="c-modal--reward-order__shipping-info">
          <div class="c-modal--reward-order__shipping-info__buttons
                      c-modal--reward-order__shipping-info__buttons--default-mode">
            <button class="c-button" @click="editingAddress = true">{{ $t('web.catalog_order_modal.edit_button') }}</button>
          </div>
          <h2 class="c-modal--reward-order__shipping-info__h2">{{ $t('web.catalog_order_modal.shipping_info') }}</h2>
          <div class="c-modal--reward-order__shipping-info__field">
            <h3 class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_first_name') }}</h3>
            <p class="u-paragraph" v-if="participant.shipping_first_name">{{ participant.shipping_first_name }}</p>
            <p class="u-paragraph u-paragraph--empty-field" v-else>{{ $t('web.catalog_order_modal.not_entered') }}</p>
          </div>
          <div class="c-modal--reward-order__shipping-info__field">
            <h3 class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_last_name') }}</h3>
            <p class="u-paragraph" v-if="participant.shipping_last_name">{{ participant.shipping_last_name }}</p>
            <p class="u-paragraph u-paragraph--empty-field" v-else>{{ $t('web.catalog_order_modal.not_entered') }}</p>
          </div>
          <div class="c-modal--reward-order__shipping-info__field">
            <h3 class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_address') }}</h3>
            <address class="u-paragraph" v-if="!addressEmpty">
              {{ participant.shipping_address1 }}<br>
              {{ participant.shipping_address2 }}<br>
              {{ participant.shipping_city }}, {{ participant.shipping_state }} {{ participant.shipping_zip_code }}<br>
              {{ getDropdownLabel(participant.shipping_country, metadata.shipping_country.options) }}
            </address>
            <address class="u-paragraph u-paragraph--empty-field" v-else>
              {{ $t('web.catalog_order_modal.not_entered') }}
            </address>
          </div>
          <div class="c-modal--reward-order__shipping-info__field">
            <h3 class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_email') }}</h3>
            <p class="u-paragraph u-force-wrap" v-if="participant.shipping_email">{{ participant.shipping_email }}</p>
            <p class="u-paragraph u-paragraph--empty-field" v-else>{{ $t('web.catalog_order_modal.not_entered') }}</p>
          </div>
          <div class="c-modal--reward-order__shipping-info__field">
            <h3 class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_phone') }}</h3>
            <p class="u-paragraph" v-if="participant.shipping_phone">{{ participant.shipping_phone }}</p>
            <p class="u-paragraph u-paragraph--empty-field" v-else>{{ $t('web.catalog_order_modal.not_entered') }}</p>
          </div>
        </div>

        <div v-if="editingAddress" class="c-modal--reward-order__shipping-info">
          <h2 class="c-modal--reward-order__shipping-info__h2">{{ $t('web.catalog_order_modal.shipping_info') }}</h2>
          <div class="c-modal--reward-order__shipping-info">
            <label for="shipping_first_name" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_first_name') }}*</label>
            <input type="text" name="shipping_first_name" v-model="participant.shipping_first_name" tabindex="1">
            <div v-for="error in errors.shipping_first_name">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
          </div>
          <div class="c-modal--reward-order__shipping-info">
            <label for="shipping_last_name" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_last_name') }}*</label>
            <input type="text" name="shipping_last_name" v-model="participant.shipping_last_name" tabindex="1">
            <div v-for="error in errors.shipping_last_name">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
          </div>
          <div class="c-modal--reward-order__shipping-info-address__city-state-zip">
            <label for="shipping_address1" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_address1') }}*</label>
            <input type="text" name="shipping_address1" v-model="participant.shipping_address1" tabindex="2">
            <div v-for="error in errors.shipping_address1">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
            <label for="shipping_address2" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_address2') }}</label>
            <input type="text" name="shipping_address2" v-model="participant.shipping_address2" tabindex="3">
            <div v-for="error in errors.shipping_address2">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
            <label for="shipping_city" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_city') }}*</label>
            <input type="text" name="shipping_city" v-model="participant.shipping_city" tabindex="4">
            <div v-for="error in errors.shipping_city">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
            <label for="shipping_state" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_state') }}*</label>
            <select name="shipping_state" v-model="participant.shipping_state" tabindex="5">
              <option value=""></option>
              <option v-for="item in metadata.shipping_state.options" v-bind:value="item.value" >{{ item.label }}</option>
            </select>
            <div v-for="error in errors.shipping_state">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
            <label for="shipping_zip_code" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_zip') }}*</label>
            <input type="text" maxlength="6" name="shipping_zip_code" v-model="participant.shipping_zip_code" tabindex="6">
            <div v-for="error in errors.shipping_zip_code">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
            <label for="shipping_country" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_country') }}*</label>
            <select name="shipping_country" v-model="participant.shipping_country" tabindex="7">
              <option value=""></option>
              <option v-for="item in metadata.shipping_country.options" v-bind:value="item.value" >{{ item.label }}</option>
            </select>
            <div v-for="error in errors.shipping_country">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
          </div><!-- // c-card--setting__fieldset–-address__city-state-zip -->
          <div class="c-modal--reward-order__shipping-info__field">
            <label for="shipping_email" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_email') }}*</label>
            <input type="email" name="shipping_email" v-model="participant.shipping_email" tabindex="8">
            <div v-for="error in errors.shipping_email">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
          </div>
          <div class="c-modal--reward-order__shipping-info__field">
            <label for="shipping_phone" class="c-modal--reward-order__shipping-info__field__h3">{{ $t('web.catalog_order_modal.shipping_phone') }}*</label>
            <input type="text" name="shipping_phone" v-model="participant.shipping_phone" tabindex="9">
            <div v-for="error in errors.shipping_phone">
              <div class="c-validation t-alert-danger">{{ error }}</div>
            </div>
          </div>
          <div class="c-modal--reward-order__shipping-info__buttons
                      c-modal--reward-order__shipping-info__buttons--edit-mode">
            <button class="c-button" @click="reset()" tabindex="10">{{ $t('web.catalog_order_modal.cancel_button') }}</button>
            <button class="c-button t-button-primary" @click="save()" tabindex="11">{{ $t('web.catalog_order_modal.save_button') }}</button>
          </div>
        </div>

      </div>


      <div v-if="shippingIncomplete">
        <div class="c-form-validation t-alert-warning">
          {{ $t('web.catalog_order_modal.incomplete_shipping_warning') }}
        </div>
      </div>


      <div class="c-modal--reward-order__actions">
        <button class="c-button c-modal--reward-order__actions__button t-button-plain"
                @click="$emit('close')"
                :disabled="confirming">
                {{ $t('web.catalog_order_modal.cancel_button') }}
        </button>
        <button class="c-button c-modal--reward-order__actions__button t-button-primary"
                @click="confirm()"
                :disabled="confirming || shippingIncomplete || editingAddress || notEnoughPoints || priceOutOfRange">
                {{ $t('web.catalog_order_modal.redeem_button') }}
        </button>
      </div>


    </section>


    <div class="c-modal__overlay"></div>



  </div>
</template>





<script>
import API from '@/services'
import validate from 'validate.js'
import { mapGetters } from 'vuex'
import VueNumeric from 'vue-numeric'
import { get } from 'lodash'
import util from '@/functions'

export default {
  data () {
    return {
      confirming: false,
      editingAddress: false,
      shippingIncomplete: true,
      metadata: this.$store.state.websiteConfig.metadata.Participant,
      participant: JSON.parse(JSON.stringify(this.$store.state.participant)),
      addressFields: [
        'shipping_first_name',
        'shipping_last_name',
        'shipping_address1',
        'shipping_address2',
        'shipping_city',
        'shipping_state',
        'shipping_city',
        'shipping_zip_code',
        'shipping_country',
        'shipping_email',
        'shipping_phone'
      ],
      errors: {},
      price: 0,
      quantity: 1,
      hasRange: false,
      minPrice: 0,
      maxPrice: 0,
      minDefDollarPrice: 0,
      maxDefDollarPrice: 0,
      dollarPriceInserted: 0
    }
  },
  mounted () {
    this.shippingIncomplete = !this._validateFields()
    this.errors = {}
    // Set the price of the reward.
    this.price = this.currencyCode
      ? get(this.rewardDetails, 'supplier_items[0].prices.sale_price.' + this.currencyCode)
      : this.rewardDetails['supplier_items'][0]['prices']['sale_price'][0]

    /** Set Price Range of the Reward */
    this.hasRange = this.rewardDetails['supplier_items'][0]['prices']['has_range']
    if (this.hasRange) {
      this.minPrice = this.rewardDetails['supplier_items'][0]['prices']['sale_price_range']['min']
      this.maxPrice = this.rewardDetails['supplier_items'][0]['prices']['sale_price_range']['max']
      this.minDefDollarPrice = parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['min'])
      this.maxDefDollarPrice = parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['max'])
      /** Set initial dollar price */
      this.dollarPriceInserted = parseFloat(this.rewardDetails['supplier_items'][0]['prices']['default_dollar_price_range']['min'])
    }
  },
  components: {
    'vue-numeric': VueNumeric
  },
  computed: {
    ...mapGetters([
      'rewardDetails'
    ]),
    currencyCode () {
      return this.participant.points_currency_code
    },
    rewardSpecs () {
      return this.rewardDetails !== null ? JSON.parse(this.rewardDetails.specifications) : null
    },
    addressEmpty () {
      return !(this.participant.shipping_address1 || this.participant.shipping_address2 || this.participant.shipping_city ||
        this.participant.shipping_state || this.participant.shipping_zip_code || this.participant.shipping_country)
    },
    pointsBalance () {
      return this.participant.points_balance - this.totalPrice
    },
    totalPrice () {
      return this.individualPrice * this.quantity
    },
    individualPrice () {
      if (this.hasRange) {
        let dollarPrice = this.dollarPriceInserted + (this.dollarPriceInserted * this.rewardDetails['supplier_items'][0]['markup'] / 100)

        return dollarPrice / this.rewardDetails['supplier_items'][0]['point_conversion_rate']
      }

      return this.price
    },
    notEnoughPoints () {
      return this.totalPrice > this.participant.points_balance
    },
    showGiftCardMessage () {
      return this.rewardDetails.item_type.type.toLowerCase().includes('gift card')
    },
    priceOutOfRange () {
      return this.hasRange && (this.dollarPriceInserted < this.minDefDollarPrice || this.dollarPriceInserted > this.maxDefDollarPrice)
    }
  },
  methods: {
    getDropdownLabel (value, options) {
      return util.getDropdownLabel(value, options)
    },
    reset () {
      this.editingAddress = false
      this.participant = JSON.parse(JSON.stringify(this.$store.state.participant))
      this.errors = {}
    },
    save () {
      var valid
      var self = this
      valid = this._validateFields()
      if (valid) {
        var fields = {}
        for (var i in this.addressFields) {
          fields[this.addressFields[i]] = this.participant[this.addressFields[i]]
        }
        let formData = new FormData()
        formData.append('field_values', JSON.stringify(fields))
        API.postAuthenticated('participants/profile', formData)
        .then((response) => {
          self.$store.commit('UPDATE_PARTICIPANT', response.data.participant)
          self.reset()
          self.editingAddress = false
          self.shippingIncomplete = false
        })
        .catch((error) => {
          // server-side validation
          if (error.response && error.response.status === 400) {
            self.errors = error.response.data.errors
          }
        })
      }
    },
    _validateFields () {
      var constraints = {
        shipping_first_name: { presence: { message: this.$t('web.catalog_order_modal.shipping_first_name_required') } },
        shipping_last_name: { presence: { message: this.$t('web.catalog_order_modal.shipping_last_name_required') } },
        shipping_phone: { presence: { message: this.$t('web.catalog_order_modal.shipping_phone_required') } },
        shipping_address1: { presence: { message: this.$t('web.catalog_order_modal.shipping_address1_required') } },
        shipping_city: { presence: { message: this.$t('web.catalog_order_modal.shipping_city_required') } },
        shipping_state: { presence: { message: this.$t('web.catalog_order_modal.shipping_state_required') } },
        shipping_zip_code: { presence: { message: this.$t('web.catalog_order_modal.shipping_zip_required') } },
        shipping_country: { presence: { message: this.$t('web.catalog_order_modal.shipping_country_required') } },
        shipping_email: {
          presence: { message: this.$t('web.catalog_order_modal.shipping_email_required') },
          email: { message: this.$t('web.catalog_order_modal.shipping_email_invalid') }
        }
      }
      var validation = {}
      for (var i in this.addressFields) {
        if (typeof constraints[this.addressFields[i]] !== 'undefined') {
          validation[this.addressFields[i]] = constraints[this.addressFields[i]]
        }
      }
      var errors = validate(this.participant, validation, {fullMessages: false})
      if (typeof errors === 'undefined') {
        this.errors = {}
        return true
      } else {
        this.errors = errors
        return false
      }
    },
    confirm () {
      this.confirming = true
      this.$emit('confirm', { quantity: this.quantity, dollar_price: this.dollarPriceInserted, point_price: this.individualPrice })
    }
  }
}

</script>

<style scoped>
.quantity_container {
  padding: 15px 0;
}
.quantity_select_container {
  text-align: end;
  width: 25%;
  color: #000;
}
.quantity_select {
  padding: 5px 4px 4px 4px;
  margin-top: 5px;
}
.quantity_label {
  margin-bottom: 4px;
}
.reward_name {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// OrderModal.vue?650c5e0e